import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function reportSignaturesReducer(
  state = initialState.reportSignatures,
  action
) {
  switch (action.type) {
    case types.LOAD_REPORTSIGNATURES_SUCCESS:
      return action.reportSignatures;
    case types.SAVE_REPORTSIGNATURE_OPTIMISTIC:
      return state.filter(
        (reportSignatures) =>
          reportSignatures.reportSignatureId === action.userSignature
      );
    default:
      return state;
  }
}
